import { render, staticRenderFns } from "./CustomerUserDetail.vue?vue&type=template&id=c284c626"
import script from "./CustomerUserDetail.vue?vue&type=script&lang=js"
export * from "./CustomerUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports